if(!customElements.get('video-container')) {

  class Player extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-play-button]');
      this.playButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.start();
      });
    }
  
    start() {
  
      // pause all the other video's
      document.querySelectorAll("video-container").forEach((el) => {
        el.querySelector('video').pause();
      });
  
      // play the video, add controls, hide custom play button
      this.video.setAttribute('controls', true);
      this.video.play();
      this.playButton.classList.add('is-hidden');
  
    }
  
  }
  
  window.Player = Player;
  customElements.define('video-container', Player);

}